(function () {
  "use strict";

  if (window.__SPARC_STEERING_SERIES_NAV_V1_2__) return;
  window.__SPARC_STEERING_SERIES_NAV_V1_2__ = true;

  var SERIES = [
    {
      key: "all",
      label: "ALL WHEELS",
      longLabel: "All Steering Wheels",
      fallbackHref: "/collections/all-steering-wheels"
    },
    {
      key: "garage",
      label: "GARAGE",
      longLabel: "Garage Series",
      fallbackHref: "/collections/garage-series"
    },
    {
      key: "muscle",
      label: "MUSCLE",
      longLabel: "Muscle Series",
      fallbackHref: "/collections/muscle-series"
    },
    {
      key: "driver",
      label: "DRIVER",
      longLabel: "Driver Series",
      fallbackHref: "/collections/driver-series"
    },
    {
      key: "classic",
      label: "CLASSIC",
      longLabel: "Classic Series",
      fallbackHref: "/collections/classic-series"
    },
    {
      key: "heritage",
      label: "HERITAGE",
      longLabel: "Heritage Series",
      fallbackHref: "/collections/heritage-series"
    }
  ];

  var PANEL_TO_SERIES = [
    {
      key: "garage",
      ids: [
        "sparc-garage-configurator"
      ]
    },
    {
      key: "muscle",
      ids: [
        "sparc-muscle-configurator",
        "sparc-muscle-round-configurator"
      ]
    },
    {
      key: "driver",
      ids: [
        "sparc-driver-configurator"
      ]
    },
    {
      key: "classic",
      ids: [
        "sparc-classic-3100-configurator",
        "sparc-classic-squarebody-configurator"
      ]
    },
    {
      key: "heritage",
      ids: [
        "sparc-heritage-configurator"
      ]
    }
  ];

  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function currentSeriesFromPath() {
    var path =
      String(
        window.location.pathname || ""
      ).toLowerCase();

    if (
      path.indexOf(
        "/collections/garage-series/"
      ) !== -1
    ) {
      return "garage";
    }

    if (
      path.indexOf(
        "/collections/muscle-series/"
      ) !== -1
    ) {
      return "muscle";
    }

    if (
      path.indexOf(
        "/collections/driver-series/"
      ) !== -1
    ) {
      return "driver";
    }

    if (
      path.indexOf(
        "/collections/classic-series/"
      ) !== -1
    ) {
      return "classic";
    }

    if (
      path.indexOf(
        "/collections/heritage-series/"
      ) !== -1
    ) {
      return "heritage";
    }

    return "";
  }

  function currentSeriesFromPanel() {
    for (
      var i = 0;
      i < PANEL_TO_SERIES.length;
      i++
    ) {
      var item =
        PANEL_TO_SERIES[i];

      for (
        var j = 0;
        j < item.ids.length;
        j++
      ) {
        if (
          document.getElementById(
            item.ids[j]
          )
        ) {
          return item.key;
        }
      }
    }

    return "";
  }

  function currentSeries() {
    return (
      currentSeriesFromPath() ||
      currentSeriesFromPanel()
    );
  }

  function configuratorIsActive() {
    return !!currentSeriesFromPanel();
  }

  function exactAnchorHref(text) {
    var wanted =
      clean(text).toLowerCase();

    var links =
      Array.prototype.slice.call(
        document.querySelectorAll("a[href]")
      );

    var match =
      links.find(
        function (link) {
          return (
            clean(
              link.textContent
            ).toLowerCase() ===
            wanted
          );
        }
      );

    return match
      ? match.getAttribute("href")
      : "";
  }

  function resolvedHref(item) {
    return (
      exactAnchorHref(
        item.longLabel
      ) ||
      item.fallbackHref
    );
  }

  function currentSeriesItem(key) {
    return (
      SERIES.find(
        function (item) {
          return item.key === key;
        }
      ) || null
    );
  }

  function runtimeBreadcrumbWrap() {
    var candidates =
      Array.prototype.slice.call(
        document.querySelectorAll(
          '[id$="-runtime-breadcrumb-wrap"]'
        )
      );

    return (
      candidates.find(
        function (node) {
          if (!node) return false;

          var style =
            window.getComputedStyle(node);

          var rect =
            node.getBoundingClientRect();

          return (
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            rect.width > 0 &&
            rect.height > 0
          );
        }
      ) || null
    );
  }

  function createLink(item, activeKey) {
    var link =
      document.createElement("a");

    link.className =
      "sparc-series-nav__link";

    link.href =
      resolvedHref(item);

    link.textContent =
      item.label;

    if (
      item.key === activeKey
    ) {
      link.classList.add(
        "is-active"
      );

      link.setAttribute(
        "aria-current",
        "page"
      );
    }

    return link;
  }

  var stickyController = null;

  function scrollY() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0
    );
  }

  function createStickyController(shell) {
    if (!shell) return null;

    var existingHost =
      shell.closest(
        ".sparc-series-nav-sticky-host"
      );

    var host =
      existingHost;

    if (!host) {
      host =
        document.createElement(
          "div"
        );

      host.className =
        "sparc-series-nav-sticky-host";

      shell.parentNode.insertBefore(
        host,
        shell
      );

      host.appendChild(
        shell
      );
    }

    var state = {
      shell: shell,
      host: host,
      naturalTop: 0,
      naturalHeight: 0,
      naturalLeft: 0,
      naturalWidth: 0,
      fixed: false,
      rafPending: false,
      resizeTimer: null
    };

    function hostRect() {
      return host.getBoundingClientRect();
    }

    function shellIsInHost() {
      return (
        shell.parentNode === host
      );
    }

    function clearFixedInline() {
      shell.style.removeProperty(
        "--sparc-series-fixed-left"
      );

      shell.style.removeProperty(
        "--sparc-series-fixed-width"
      );
    }

    function returnToHost() {
      if (
        !shellIsInHost()
      ) {
        host.appendChild(
          shell
        );
      }

      shell.classList.remove(
        "is-fixed"
      );

      clearFixedInline();

      host.style.removeProperty(
        "height"
      );

      state.fixed =
        false;
    }

    function measure() {
      /*
        Always establish geometry from normal document flow.
      */
      var wasFixed =
        state.fixed;

      if (wasFixed) {
        returnToHost();
      }

      var rect =
        hostRect();

      var shellRect =
        shell.getBoundingClientRect();

      var styles =
        window.getComputedStyle(
          shell
        );

      var marginTop =
        parseFloat(
          styles.marginTop
        ) || 0;

      var marginBottom =
        parseFloat(
          styles.marginBottom
        ) || 0;

      state.naturalTop =
        rect.top +
        scrollY();

      /*
        Host is flow-root, but keep an explicit outer-height record as a
        defensive fallback for old Supply margin behavior.
      */
      state.naturalHeight =
        Math.max(
          rect.height,
          shellRect.height +
          marginTop +
          marginBottom
        );

      state.naturalLeft =
        rect.left;

      state.naturalWidth =
        rect.width;

      if (wasFixed) {
        updateNow();
      }
    }

    function enterFixed() {
      if (state.fixed) {
        return;
      }

      var rect =
        hostRect();

      /*
        Freeze the exact space the navigation occupied before portaling the
        live bar to body. This prevents any content jump.
      */
      host.style.setProperty(
        "height",
        state.naturalHeight + "px"
      );

      state.naturalLeft =
        rect.left;

      state.naturalWidth =
        rect.width;

      document.body.appendChild(
        shell
      );

      shell.style.setProperty(
        "--sparc-series-fixed-left",
        state.naturalLeft + "px"
      );

      shell.style.setProperty(
        "--sparc-series-fixed-width",
        state.naturalWidth + "px"
      );

      shell.classList.add(
        "is-fixed"
      );

      state.fixed =
        true;

      window.dispatchEvent(
        new CustomEvent(
          "sparc:series-nav-fixed",
          {
            detail: {
              fixed: true,
              height:
                shell.getBoundingClientRect()
                  .height
            }
          }
        )
      );
    }

    function leaveFixed() {
      if (!state.fixed) {
        return;
      }

      returnToHost();

      window.dispatchEvent(
        new CustomEvent(
          "sparc:series-nav-fixed",
          {
            detail: {
              fixed: false
            }
          }
        )
      );
    }

    function updateNow() {
      state.rafPending =
        false;

      var y =
        scrollY();

      if (
        y >=
        state.naturalTop
      ) {
        enterFixed();
      } else {
        leaveFixed();
      }
    }

    function queueUpdate() {
      if (state.rafPending) {
        return;
      }

      state.rafPending =
        true;

      window.requestAnimationFrame(
        updateNow
      );
    }

    function onResize() {
      window.clearTimeout(
        state.resizeTimer
      );

      state.resizeTimer =
        window.setTimeout(
          function () {
            measure();
            queueUpdate();
          },
          80
        );
    }

    window.addEventListener(
      "scroll",
      queueUpdate,
      {
        passive: true
      }
    );

    window.addEventListener(
      "resize",
      onResize
    );

    /*
      Initial measurement is deferred one frame so the runtime breadcrumb
      and navigation have completed layout.
    */
    window.requestAnimationFrame(
      function () {
        measure();
        queueUpdate();

        /*
          Browser scroll restoration can happen slightly after first paint.
        */
        window.setTimeout(
          function () {
            measure();
            queueUpdate();
          },
          120
        );
      }
    );

    return state;
  }

  function installStickyController(
    shell
  ) {
    if (
      stickyController
    ) {
      return;
    }

    stickyController =
      createStickyController(
        shell
      );

    if (
      stickyController
    ) {
      console.info(
        "[SPARC SERIES NAV V1.2] Fixed-position sticky controller active."
      );
    }
  }

  function buildNavigation() {
    var existingNav =
      document.getElementById(
        "sparc-steering-series-nav"
      );

    if (existingNav) {
      installStickyController(
        existingNav
      );

      return true;
    }

    if (
      !configuratorIsActive()
    ) {
      return false;
    }

    var activeKey =
      currentSeries();

    if (!activeKey) {
      return false;
    }

    var breadcrumbWrap =
      runtimeBreadcrumbWrap();

    if (!breadcrumbWrap) {
      return false;
    }

    var activeItem =
      currentSeriesItem(
        activeKey
      );

    if (!activeItem) {
      return false;
    }

    var shell =
      document.createElement(
        "section"
      );

    shell.id =
      "sparc-steering-series-nav";

    shell.className =
      "sparc-series-nav";

    shell.setAttribute(
      "aria-label",
      "Steering wheel series navigation"
    );

    var top =
      document.createElement(
        "div"
      );

    top.className =
      "sparc-series-nav__top";

    var label =
      document.createElement(
        "div"
      );

    label.className =
      "sparc-series-nav__eyebrow";

    label.textContent =
      "EXPLORE STEERING WHEELS";

    var back =
      document.createElement(
        "a"
      );

    back.className =
      "sparc-series-nav__back";

    back.href =
      resolvedHref(
        activeItem
      );

    back.textContent =
      "← BACK TO " +
      activeItem.longLabel.toUpperCase();

    top.appendChild(
      label
    );

    top.appendChild(
      back
    );

    shell.appendChild(
      top
    );

    var desktopNav =
      document.createElement(
        "nav"
      );

    desktopNav.className =
      "sparc-series-nav__links";

    desktopNav.setAttribute(
      "aria-label",
      "Browse steering wheel series"
    );

    SERIES.forEach(
      function (item) {
        desktopNav.appendChild(
          createLink(
            item,
            activeKey
          )
        );
      }
    );

    shell.appendChild(
      desktopNav
    );

    var mobile =
      document.createElement(
        "div"
      );

    mobile.className =
      "sparc-series-nav__mobile";

    var mobileLabel =
      document.createElement(
        "label"
      );

    mobileLabel.className =
      "sparc-series-nav__mobile-label";

    mobileLabel.setAttribute(
      "for",
      "sparc-series-nav-select"
    );

    mobileLabel.textContent =
      "BROWSE STEERING WHEEL SERIES";

    var select =
      document.createElement(
        "select"
      );

    select.id =
      "sparc-series-nav-select";

    select.className =
      "sparc-series-nav__select";

    SERIES.forEach(
      function (item) {
        var option =
          document.createElement(
            "option"
          );

        option.value =
          resolvedHref(item);

        option.textContent =
          item.longLabel;

        if (
          item.key === activeKey
        ) {
          option.selected =
            true;
        }

        select.appendChild(
          option
        );
      }
    );

    select.addEventListener(
      "change",
      function () {
        if (
          select.value
        ) {
          window.location.href =
            select.value;
        }
      }
    );

    mobile.appendChild(
      mobileLabel
    );

    mobile.appendChild(
      select
    );

    shell.appendChild(
      mobile
    );

    breadcrumbWrap.insertAdjacentElement(
      "afterend",
      shell
    );

    installStickyController(
      shell
    );

    console.info(
      "[SPARC SERIES NAV V1.2] Navigation initialized.",
      {
        series: activeKey,
        breadcrumb: breadcrumbWrap.id
      }
    );

    return true;
  }

  function start() {
    if (
      buildNavigation()
    ) {
      return;
    }

    var attempts = 0;

    var timer =
      window.setInterval(
        function () {
          attempts += 1;

          if (
            buildNavigation() ||
            attempts >= 60
          ) {
            window.clearInterval(
              timer
            );
          }
        },
        250
      );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
